const UserIconV1 = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clip-path='url(#clip0_74691_207)'>
        <path
          d='M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z'
          fill='#8B5CF6'
        />
        <path
          d='M16.2011 14.1352C16.2382 14.2854 16.2393 14.4423 16.2045 14.5931C16.1697 14.7438 16.0999 14.8843 16.0007 15.0031C15.2676 15.8826 14.35 16.5902 13.313 17.0758C12.276 17.5614 11.145 17.813 9.99997 17.813C8.85493 17.813 7.7239 17.5614 6.68692 17.0758C5.64995 16.5902 4.73238 15.8826 3.99919 15.0031C3.90004 14.8843 3.83023 14.7438 3.79542 14.5931C3.76061 14.4423 3.76177 14.2854 3.7988 14.1352C4.13909 12.7543 4.93034 11.5265 6.04723 10.6461C6.21383 10.5155 6.41867 10.4431 6.63034 10.4401C6.84201 10.437 7.04883 10.5035 7.21911 10.6293C7.9613 11.1813 8.93434 11.5156 9.9984 11.5156C11.0625 11.5156 12.0351 11.1813 12.7777 10.6293C12.948 10.5035 13.1548 10.437 13.3665 10.4401C13.5781 10.4431 13.783 10.5155 13.9496 10.6461C15.0676 11.526 15.86 12.7539 16.2011 14.1352Z'
          fill='white'
        />
        <path
          d='M9.99998 10.2258C11.9824 10.2258 13.5894 8.61873 13.5894 6.63633C13.5894 4.65393 11.9824 3.04688 9.99998 3.04688C8.01758 3.04688 6.41052 4.65393 6.41052 6.63633C6.41052 8.61873 8.01758 10.2258 9.99998 10.2258Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_74691_207'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserIconV1;
